// extracted by mini-css-extract-plugin
export default {"inviteMessage":"ReferralSystemComponent_inviteMessage__QYgbd"};